import TeenInstantPage from "../teen33/TeenInstantPage";

// casino/teen32 — reference title "Instant Teenpatti 2.0" (shared Instant Teenpatti page)
export default function TeenPatti32() {
  return <TeenInstantPage defaultType="teen32" title="Instant Teenpatti 2.0" />;
}
